<template>
    <ui-crud title="Inspection &amp; Test Plans" subtitle="A list of inspection-test-plans for this package"
             :fetch="fetch" :pipe-with="pipeItems">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`#ITP ${item.reference}`"
                :subtitle="`${item.lastUpdatedOn?item.lastUpdatedOn:item.createdOn}`"
                :metadata="`${item.lastUpdatedBy?item.lastUpdatedBy:item.createdBy}`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <template #edit="{ selectedItem, setEditMode, addItem, removeItem }">
            <inspection-test-plans-edit :item="selectedItem"
                                        :edit="setEditMode"
                                        :removeItem="removeItem"
                                        @print="print"
                                        :package-reference="packageReference"
                                        :add-item="addItem">
            </inspection-test-plans-edit>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode, removeItem, addItem }">
            <inspection-test-plans-edit :item="selectedItem"
                                        :edit="setEditMode"
                                        :removeItem="removeItem"
                                        @print="print"
                                        :package-reference="packageReference"
                                        :add-item="addItem">
            </inspection-test-plans-edit>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <inspection-test-plans-show :item="selectedItem"
                                        :edit="setEditMode"
                                        :removeItem="removeItem"
                                        @print="print"
                                        :package-reference="packageReference"
                                        :add-item="addItem">
            </inspection-test-plans-show>
        </template>
    </ui-crud>
</template>

<script>
import {Contact, InspectionTestPlan} from "@models";
import moment from "moment/moment";

export default {
    props: {
        packageReference: null,
        admin: Boolean,
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async fetch() {
            return await InspectionTestPlan.list(this.packageReference)
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((route) => {
                    return query.every((token) => {
                        return route.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            },100)
                        }
                    )
                }
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
    },
    async mounted() {
    }
}
</script>
